import {
  GeneralIcon
} from "./chunk-JQYOYMSZ.mjs";

// src/icon/src/general/bin.tsx
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Path = () => /* @__PURE__ */ jsxs(Fragment, { children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M17.3204 21.3845H6.59601C6.18969 21.3845 5.80001 21.2232 5.51269 20.9358C5.22537 20.6485 5.06396 20.2588 5.06396 19.8524V6.06396H18.8524V19.8524C18.8524 20.2588 18.6911 20.6485 18.4037 20.9358C18.1164 21.2232 17.7267 21.3845 17.3204 21.3845Z",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M9.66016 16.7884V10.6602",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M14.2566 16.7884V10.6602",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M2 6.06396H21.9167",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M14.2564 3H9.66022C9.2539 3 8.86422 3.16141 8.5769 3.44873C8.28958 3.73604 8.12817 4.12573 8.12817 4.53206V6.06412H15.7884V4.53206C15.7884 4.12573 15.627 3.73604 15.3397 3.44873C15.0524 3.16141 14.6627 3 14.2564 3Z",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5"
    }
  )
] });
var Bin = (props) => /* @__PURE__ */ jsx(GeneralIcon, { ...props, children: /* @__PURE__ */ jsx(Path, {}) });

export {
  Bin
};
